export enum BaseLegalEntityFormFieldNames {
  LegalReason = 'legalReason',
  RegistrationNumber = 'registrationNumber',
  RcsNumber = 'rcsNumber',
  RcsCity = 'rcsCity',
  Capital = 'capital',
  OriasNumber = 'oriasNumber',
  Rcp = 'rcp',
}
